
import { normalizeDate } from './dateParser';
import { formatDateRange } from './dateFormatter';

/**
 * Utility functions for checking date availability against iCal data
 */

export const isDateRangeAvailable = (
  checkIn: Date,
  checkOut: Date,
  unavailableDates: Date[]
): boolean => {
  // Create array of all dates in the requested range (excluding checkout date)
  const requestedDates: Date[] = [];
  const current = new Date(checkIn);
  
  while (current < checkOut) {
    requestedDates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  // Check if any requested date conflicts with unavailable dates
  const hasConflict = requestedDates.some(requestedDate => {
    return unavailableDates.some(unavailableDate => {
      const requested = normalizeDate(requestedDate);
      const unavailable = normalizeDate(unavailableDate);
      return requested.getTime() === unavailable.getTime();
    });
  });

  const isAvailable = !hasConflict;
  
  return isAvailable;
};

// Re-export formatDateRange for backward compatibility
export { formatDateRange };
